import { render, staticRenderFns } from "./SeniorRetouchersInfoBlock.vue?vue&type=template&id=4a10253c&"
import script from "./SeniorRetouchersInfoBlock.vue?vue&type=script&lang=js&"
export * from "./SeniorRetouchersInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./SeniorRetouchersInfoBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports